import './shop-info.less';

import React from 'react';
import PropTypes from 'prop-types';

import _isEmpty from 'lodash/fp/isEmpty';

import pageIcon from '../../../../assets/img/market/page.svg';
import TermsPopup from './../terms-popup/main';

class Main extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isTermsPopupShowed: false
		};
		this.showTermsPopup = this.showTermsPopup.bind(this);
		this.hideTermsPopup = this.hideTermsPopup.bind(this);
	}
	showTermsPopup() {
		this.setState({ isTermsPopupShowed: true });
	}
	hideTermsPopup() {
		this.setState({ isTermsPopupShowed: false });
	}
	componentDidMount () {
		let counter = 10;
		let findGoodAndScroll = setInterval(function() {
			counter--;
			document.getElementById(document.location.hash) &&
			document.getElementById(document.location.hash).scrollIntoView();
			if (counter === 0) {
				clearInterval(findGoodAndScroll);
			}
		}, 100);
	}
	render() {
		const {intl, user} = this.props;
		return (
			<div className='shop-info'>
				<div className='shop-info__title'>{intl('Gifts')}</div>
				<div className="shop-info__user-info">
					<div className={`shop-info__points ${_isEmpty(user) && 'no-border'}`}>
						{!_isEmpty(user)
							? (<div>
								<div className="shop-info__points-desc">
									{intl('Your points')}
								</div>
								<div className="shop-info__points-number">
									{Math.round(user.contest_points * 100)/100 || 0}
								</div>
							</div>): null
						}
					</div>

					<div className="shop-info__conditions">
						<div className="shop-info__conditions-icon">
							<img
								className="shop-info__conditions-img"
								src={pageIcon}
								alt=""
							/>
						</div>
						<a onClick={this.showTermsPopup}
							className="shop-info__conditions-desc"
						>{intl('Rules of affiliate program')}</a>
						{this.state.isTermsPopupShowed &&
							<TermsPopup
								intl={intl}
								isTermsPopupShowed={this.state.isTermsPopupShowed}
								hideTermsPopup={this.hideTermsPopup}
							/>}
					</div>
				</div>

			</div>
		);
	}
}

Main.propTypes = {
	intl: PropTypes.func,
	user: PropTypes.object
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/store/shop-info.js